import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from "@mui/material";
import { useFormContext } from "../form/IForm";
import { useConfig } from "../store/selectors/useConfig";

const ISelectBox = ({
  model,
  label,
  lookup = null,
  options = [],
  variant = "outlined",
  displayLabel = true,
  ...rest
}) => {
  const form = useFormContext();
  const { getLookupValues } = useConfig();
  const opts = getLookupValues(lookup) || options || [];
  const rawVal = form?.values[model];
  const selectValue = rawVal !== undefined && rawVal !== null ? rawVal : (opts[0]?.key ?? "");

  return (
    <FormControl
      size="small"
      variant={variant}
      fullWidth
      error={form.touched[model] && Boolean(form.errors[model])}
    >
      {displayLabel && <InputLabel>{label}</InputLabel>}
      <Select
        value={selectValue}
        onChange={form?.handleChange}
        onBlur={form?.handleBlur}
        name={model}
        label={displayLabel ? label : ""}
        {...rest}
      >
        <MenuItem value="" disabled>Select</MenuItem>
        {(opts || []).map((option) => (
          <MenuItem key={option.key} value={option.key}>
            {option.value}
          </MenuItem>
        ))}
      </Select>
      {form.touched[model] && form.errors[model] && (
        <FormHelperText>{form.errors[model]}</FormHelperText>
      )}
    </FormControl>
  );
};

export default ISelectBox;
